import type React from 'react';
import type { SxProps, Theme } from '@mui/material/styles';

export const approverRowSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  py: 0.75,
  px: 1.5,
  bgcolor: 'background.paper',
  border: '1px solid',
  borderColor: 'grey.300',
  borderRadius: 1,
  mb: 0.75,
  boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
  '&:hover': {
    bgcolor: 'grey.50',
    borderColor: 'grey.400',
  },
};

export const getDragHandleSx = (disabled: boolean): SxProps<Theme> => ({
  display: 'flex',
  alignItems: 'center',
  cursor: disabled ? 'default' : 'grab',
  '&:active': {
    cursor: disabled ? 'default' : 'grabbing',
  },
  color: disabled ? 'action.disabled' : 'text.secondary',
});

export const getApproverTextSx = (disabled: boolean): SxProps<Theme> => ({
  flex: 1,
  color: disabled ? 'text.disabled' : 'text.primary',
});

export const approverIndexSx: SxProps<Theme> = {
  fontWeight: 600,
  mr: 1,
};

export const deleteButtonSx: SxProps<Theme> = {
  color: 'text.primary',
  p: 0.5,
};

export const sectionTitleSx: SxProps<Theme> = {
  mb: 1,
  fontWeight: 600,
};

export const infoAlertSx: SxProps<Theme> = {
  mb: 1,
};

export const autocompleteListboxSx: SxProps<Theme> = {
  maxHeight: 200,
  '& .MuiAutocomplete-option': {
    display: 'flex',
    py: 1.25,
    px: 1.5,
    minHeight: 44,
    alignItems: 'center',
    '&:hover': {
      backgroundColor: 'action.hover',
    },
    '&.Mui-focused': {
      backgroundColor: 'action.hover',
    },
  },
};

export const getOptionSx = (isSelected: boolean): React.CSSProperties => ({
  backgroundColor: isSelected ? 'rgba(25, 118, 210, 0.08)' : undefined,
});

export const getOptionTextSx = (isSelected: boolean): SxProps<Theme> => ({
  flex: 1,
  fontWeight: isSelected ? 600 : 400,
});
